/*
 * @Author: wufei
 * @Date: 2020-08-08 17:19:32
 * @LastEditTime: 2020-08-08 17:20:02
 * @Description:
 * @FilePath: \mobile-revive\src\api\user\index.js
 */
import fetch from '@/utils/fetch'

/** 钉钉相关接口*/

// 获取钉钉配置信息
export function getConfigInfo(params) {
    return fetch({
        url: '/venus/user/getConfigInfo',
        method: 'post',
        params: params
    })
}

// 获取钉钉用户信息
export function getUsernfo(params) {
    return fetch({
        url: '/venus/user/getUsernfo',
        method: 'post',
        params: params
    })
}

// 获取用户信息
export function getUserPermissionInfo() {
    return fetch.request({
        url: '/sys/userInfo',
        method: 'get'
    })
}
